module.exports = __webpack_public_path__ + "img/im.f32e774c.png";